import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Component from "./component";
import {  setStep, activateFirstStep, activateLastStep } from "../lead-form/actions";
import { resetRegistrationData } from "../car-registration-number/actions";

const mapStateToProps = () => {};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setStepConnect: setStep,
    resetRegistrationDataConnect: resetRegistrationData,
    activateFirstStepConnect: activateFirstStep,
    activateLastStepConnect: activateLastStep
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Component);
